import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useUtilityClasses } from "./button.classes.js";
import { ButtonRoot } from "./button.styles.js";
import { useThemeProps } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
const Button = forwardRef(function Button2(inProps, ref) {
  const props = useThemeProps({ props: inProps, name: "TrueButton" });
  const {
    children,
    loading,
    size,
    disabled,
    component,
    eventId,
    startIcon,
    endIcon,
    color = "tertiary",
    ...other
  } = props;
  const ownerState = {
    color,
    loading,
    size,
    disabled,
    startIcon,
    endIcon,
    ...other
  };
  const classes = useUtilityClasses(ownerState);
  return /* @__PURE__ */ jsxs(
    ButtonRoot,
    {
      ...other,
      color: color !== "tertiary" ? color : void 0,
      component,
      ownerState,
      disabled: disabled || loading,
      startIcon: !loading && startIcon,
      endIcon: !loading && endIcon,
      size,
      ref,
      classes,
      "data-eventid": eventId,
      children: [
        loading && /* @__PURE__ */ jsx(CircularProgress, { size: "initial", color: "inherit" }),
        /* @__PURE__ */ jsx("span", { className: classes.label, children })
      ]
    }
  );
});
export {
  Button
};
//# sourceMappingURL=button.component.js.map
